import { AGGREGATE_NAMES, LOAN_REQUEST_RESOLVERS, SearchMode, SearchType } from 'cpool-constants';
import { schemaLoanRequestResolver_Find } from 'cpool-tables/backend-resolvers';
import { useDebounce } from 'use-debounce';

import { useAggregateQuery } from '~/queryUtils/useQuery';

const MIN_QUERY_LENGTH = 2;
const RESULT_LIMIT = 8;

// Free-text search over the `find` resolver with SearchType.GLOBAL and a fixed result limit.
export const useSearchLoanRequests = (query: string) => {
    const [debouncedQuery] = useDebounce(query.trim(), 300);

    return useAggregateQuery({
        acl: {},
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.find,
        schema: schemaLoanRequestResolver_Find,
        searchParams: {
            filter: false,
            limit: RESULT_LIMIT,
            query: debouncedQuery,
            searchFields: {},
            searchMode: SearchMode.OR,
            searchType: SearchType.GLOBAL,
        },
        tanstack: {
            enabled: debouncedQuery.length >= MIN_QUERY_LENGTH,
        },
    });
};
